export default {
  props: {},
  data() {
    return {
      reportDialog: false
    }
  },
  created() {
  },
  methods: {
    base64ToArrayBuffer(base64) {
      let binaryString = window.atob(base64);
      let binaryLen = binaryString.length;
      let bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArrayAsPdf(reportName, byte, type) {
      let blob = new Blob([byte]);
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      let fileName = reportName + type;
      link.download = fileName;
      link.click();
    },

    getPdf(reportName, data) {
      let sampleArr = this.base64ToArrayBuffer(data);
      this.saveByteArrayAsPdf(reportName, sampleArr, ".pdf");
    },
    getExcel(reportName, data) {
      let sampleArr = this.base64ToArrayBuffer(data);
      this.saveByteArrayAsPdf(reportName, sampleArr, ".xlsx");
    },

    createReport(report) {
      if (report) {
        this.$delegate('reportGenerator', 'getReport', {
          reportId: report.id,
          reportKey: report.reportKey,
          rangeModel: report.rangeModel,
          delegateData: report.delegateData
        }).then((res) => {
          this.reportDialog = true;

          if (res.result.exportType === 'PDF') {
            this.getPdf(res.result.reportName, res.result.reportData);
          } else if (res.result.exportType === 'EXCEL') {
            this.getExcel(res.result.reportName, res.result.reportData);
          }


        });
      }
    },
  },
  computed: {},
  watch: {},
  components: {}
};



